import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {RootState} from '../../app/rootReducer'

export const dealerSlice = createSlice({
    name: 'dealers',
    initialState: {
        myDealerCode: '',
    },
    reducers: {
        setMyDealerCode(
            state: RootState,
            action: PayloadAction<string | null>
        ): void {
            state.myDealerCode = action.payload
        },
    },
})

export const {setMyDealerCode} = dealerSlice.actions

export default dealerSlice.reducer
